import { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../login/AuthProvider";
import { book } from "../../components/apipath";
import Swal from "sweetalert2";
import { useNavigate, Link } from "react-router-dom";
import Address from "../registration/component/address";

function BookRequestForm() {

   const { token, mem_id, mem_status, authorized } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!authorized || String(mem_status) !== "1") {
            Swal.fire({
                icon: 'warning',
                title: '學員專屬功能',
                text: '此頁面僅限學員使用，請先完成購買',
                confirmButtonText: '了解',
                confirmButtonColor: '#224040',
            }).then(() => {
                navigate('/');
            });
        }
    }, []);

    const [formData, setFormData] = useState({
        mem_id: mem_id,
        studentName: "",
        account:"",
        core_subjects: [],
        specialty: "",
        requested_date: "",
        memo: "",
        address: "",
        status: "審核中",
        delivery_method: "",
    });
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        try {
            const authData = JSON.parse(localStorage.getItem("auth"));
            if (authData && authData.chinese_name) {
                setFormData((prevData) => ({
                    ...prevData,
                    studentName: authData.chinese_name,
                    account: authData.account,
                }));
            }
        } catch (error) {
            console.error("無法解析 auth 資料", error);
        }
    }, []);

    // 處理文字、日期輸入
    const handleChange = (e) => {
        const { name, value, type, files } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: type === "file" ? files[0] : value,
        }));
    };

    // 處理科目多選框
    const handleCheckboxChange = (e) => {
        const { value, checked } = e.target;
        
        setFormData((prevData) => {
            let updatedSubjects;
    
            if (checked) {
                // 加入科目，但確保不重複
                updatedSubjects = [...new Set([...prevData.core_subjects, value])];
            } else {
                // 移除科目
                updatedSubjects = prevData.core_subjects.filter(subject => subject !== value);
            }
    
            return {
                ...prevData,
                core_subjects: updatedSubjects,
            };
        });
    };
    

    const handleRadioChange = (e) => {
        const { value } = e.target;
    
        setFormData((prevData) => {
            const updatedSubjects = prevData.core_subjects.filter(sub => sub !== prevData.specialty);
    
            return {
                ...prevData,
                specialty: value,
                core_subjects: [...updatedSubjects, value],  // 新增新的 `specialty`
            };
        });
    };
    


    // 處理表單提交
    const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
        const dataToSend = {
            mem_id: mem_id || "",
            student_name: formData.studentName,
            core_subject: formData.core_subjects.join(","),
            requested_date: formData.requested_date || null,
            memo: formData.memo,
            address: formData.address,
            status: "審核中",
        };

        // console.log("送出的資料:", dataToSend);

        const response = await axios.post(`${book}`, dataToSend, { headers: { token } });

        if (response.status === 200) {
            Swal.fire({
                icon: "success",
                title: "申請成功",
                text: "請等待管理員審核！",
                confirmButtonText: "確認",
            });
            navigate("/member");
        }
    } catch (error) {
        console.error("申請失敗:", error);
        Swal.fire({
            icon: "error",
            title: "伺服器錯誤",
            text: "提交失敗，請稍後再試。",
            confirmButtonText: "確認",
        });
    }

    setIsSubmitting(false);
};
    return (
        <div className="container mb100 mt100">
            <h2 className="font-weight-bold pb-5 text-center">Becker CPA Exam Review 教材課本_領取預約表</h2>
            <div className="card w-75 p-5 m-auto">
                <div className="card-body">
                    
                        在拿到紙本課本之前，您也可以隨時線上閱覽 Becker 軟體內的課文電子書 (Digital Textbook)。<br/>
                        2025 年 12 月版本更新 ---
                        <div className="mt-5">
                            <ul>
                                <li>FAR 更新為 v1.4 </li>
                                <li>AUD 更新為 v1.3</li>
                                <li>REG 更新為 v1.3 </li>
                                <li>BAR 更新為 v1.3 </li>
                                <li>ISC 更新為 v1.1</li>
                                <li>TCP 更新為 v1.3</li> 
                            </ul>  
                        </div>
                    <div className="mt-5 mb-5">
                        我們儘力保持現場庫存充足，然若有短期大量預約、超過進貨數量的情況，將以您填寫此表單的預約順序，為您保留庫存，並於新訂課本運抵時通知您，敬請詳細填寫以下表格。

                        每一批書籍實際抵達時間偶爾因國際貨運公司處理清關速度而有稍快或稍慢，
                        課本書籍抵達 Becker Taiwan 辦公室當日，我們將發送通知給預約領取者。
                    </div>
                    課本寄送郵資與時長：
                    <div className="mt-2 mb-5">
                        <ul>
                            <li>
                                台灣地區 
                                郵資：便利袋快遞費每箱新台幣 100 元，因快遞公司重量限制，寄送 1-2 本為一箱，寄送 3-4 本須為兩箱。
                                時長：在有庫存情況下，填寫此表後1個工作天內將為您完成出貨、約3個工作天內收到。
                            </li>
                            <li>
                                海外地區
                                郵資：由美國 Becker 直接發貨，使用美國境內 US Post 寄送，單次寄送郵資為新台幣1,200 元(全額到匯，計算方式請向您的支付銀行確認，若無法估算，請直接另附新台幣200元之中轉行手續費)。
                                時長：在有庫存情況下，填寫此表後14個工作天內將為您完成出貨、約4週內可收到。
                            </li>
                        </ul>
                    </div>
                    付款購買匯款資訊：
                    <div className="mt-2 mb-5">
                        <ul>
                            
                            <li>
                                台灣地區 
                                收款人戶名：捷進顧問有限公司
                                受款銀行：華南商業銀行信維分行 (代碼：008 )
                                收款人帳號：149-10-010062-0
                            </li>
                            <li>
                                海外地區
                                Recipient Name: Direct Line Consulting Co.
                                Account Number: 149-10-010062-0
                                Bank: Hua Nan Commercial Bank Ltd.
                                Branch: Hsin-Wei Branch
                                SWIFT Code (Bank ID): HNBKTWTP149 
                                Bank Address: 2F, No.6, Xinyi Rd. Sec. 4, Da'an Dist., 106 Taipei City, Taiwan
                            </li>
                        </ul>
                    </div>
                    


                    <form onSubmit={handleSubmit}>
                        {/* 學員姓名 */}
                        <div className="form-group mb-4">
                            <label>學員姓名</label>
                            <input type="text" className="form-control" name="studentName" value={formData.studentName} readOnly />
                        </div>

                        {/* 備註 */}
                        <div className="form-group mb-4">
                            <label>您的 Becker 軟體帳號（email 全址）*</label>
                            <input className="form-control" name="account" value={formData.account} onChange={handleChange} />
                        </div>
                        <p>若您曾經領取過 FAR、AUD、REG、BEC，希望再次領取（BEC 以一門專科取代），則不需填寫此表單，請改填寫 <Link to="../member/add">Becker 加購表單</Link>。</p>

                        {/* 學科 */}
                        <div className="form-group mb-4">
                            <label className="mb-2">預計領取學科 (core) 課本請選擇您接下來確定會備考的科目。(皆為最新版本)</label>
                            <div className="checkbox-group">
                                <label className="form-check">
                                    <input type="checkbox" value="FAR" checked={formData.core_subjects.includes("FAR")} onChange={handleCheckboxChange} /> FAR v.1.3
                                </label>
                                <label className="form-check">
                                    <input type="checkbox" value="REG" checked={formData.core_subjects.includes("REG")} onChange={handleCheckboxChange} /> REG v1.2
                                </label>
                                <label className="form-check">
                                    <input type="checkbox" value="AUD" checked={formData.core_subjects.includes("AUD")} onChange={handleCheckboxChange} /> AUD v1.2
                                </label>
                            </div>
                        </div>

                        {/* 專科 */}
                        <div className="form-group mb-4">
                            <label className="mb-2">預計領取專科 (discipline) 課本</label>
                            請選擇您接下來確定會備考的科目。每位考生僅需選擇與領取一門專科教材，進行備考。
                            （若近幾個月預計還不會讀某一科目，建議暫時不需領取課本；待未來確定要開始讀該科時，領取當下最新版本的課本。）
                            顯示 version 為目前提供領取版本，皆為最新版本。
                            <div className="radio-group mt-2">
                                <label className="form-check">
                                    <input type="radio" name="specialty" value="TCP" checked={formData.specialty === "TCP"} onChange={handleRadioChange} /> TCP v.1.3
                                </label>
                                <label className="form-check">
                                    <input type="radio" name="specialty" value="BAR" checked={formData.specialty === "BAR"} onChange={handleRadioChange} /> BAR v.1.3
                                </label>
                                <label className="form-check">
                                    <input type="radio" name="specialty" value="ISC" checked={formData.specialty === "ISC"} onChange={handleRadioChange} /> ISC v1.1
                                </label>
                            </div>
                        </div>
                        <div className="form-group mb-4">
                            <label className="mb-2">領書方式</label><br />
                            <div className="form-check form-check-inline">
                                <input
                                    type="radio"
                                    className="form-check-input"
                                    id="delivery_post"
                                    name="delivery_method"
                                    value="post"
                                    checked={formData.delivery_method === "post"}
                                    onChange={handleChange}
                                />
                                <label className="form-check-label" htmlFor="delivery_post">郵寄</label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input
                                    type="radio"
                                    className="form-check-input"
                                    id="delivery_pickup"
                                    name="delivery_method"
                                    value="pickup"
                                    checked={formData.delivery_method === "pickup"}
                                    onChange={handleChange}
                                />
                                <label className="form-check-label" htmlFor="delivery_pickup">現場自取</label>
                            </div>
                        </div>
                        {formData.delivery_method === "post" && (
                            <div className={`form-group mb-4`}>
                                <label htmlFor="address" className="mb-2">發票/紙本教科書郵寄地址</label>
                                <Address
                                    onAddressChange={(combinedAddress) =>
                                        setFormData({ ...formData, address: combinedAddress })
                                    }
                                />
                            </div>
                        )}
                        {formData.delivery_method === "pickup" && (
                            <div className="form-group mb-4">
                                <label>欲領取時間（請選擇三日後的日期）</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    name="requested_date"
                                    value={formData.requested_date}
                                    onChange={handleChange}
                                    min={new Date(Date.now() + 3 * 24 * 60 * 60 * 1000) // 三天後
                                    .toISOString()
                                    .split("T")[0]}
                                    required
                                />
                            </div>
                        )}

                        {/* 備註 */}
                        <div className="form-group mb-4">
                            <label>備註</label>
                            若有匯款，請填寫匯款人姓名或帳號末五碼。任何其他課本相關疑問或建議，請在此留言。
                            <textarea className="form-control" name="memo" rows="3" value={formData.memo} onChange={handleChange} />
                        </div>

                        {/* 提交按鈕 */}
                        <button type="submit" className="btn btn-primary w-100" disabled={isSubmitting}>
                            {isSubmitting ? "提交中..." : "提交申請"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default BookRequestForm;
